import { BaseClient, IProduct, ISaveProduct, logisticsApi } from '../../shared';

class ProductsClient extends BaseClient<IProduct, ISaveProduct> {
    constructor() {
        super(logisticsApi, '/products');
    }
}

export const productsClient = new ProductsClient();
